import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy-deep text-gray-300">
      <div className="container-narrow py-20 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div className="space-y-4">
          <img
            src="https://customer-assets-v7afamib.emergentagent.net/job_d32-network-in/artifacts/5qxy1am6_D32BN_logo_India.webp"
            alt="D32 Business Network India"
            className="h-16 w-auto object-contain bg-white rounded-lg px-3 py-2"
          />
          <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
            A business growth network for Indian founders, SMEs and ambitious
            business owners. Powered by The Power of Connection.
          </p>
          <div className="hairline" />
        </div>

        <div>
          <div className="overline text-gold mb-5">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-gold transition">About D32</Link></li>
            <li><Link to="/membership" className="hover:text-gold transition">Membership</Link></li>
            <li><Link to="/find-a-region" className="hover:text-gold transition">Find a Region</Link></li>
            <li><Link to="/visit-a-circle" className="hover:text-gold transition">Visit a Circle</Link></li>
            <li><Link to="/masterclass" data-testid="footer-link-masterclass" className="hover:text-gold transition">Masterclass</Link></li>
            <li><Link to="/franchise" className="hover:text-gold transition">Franchise</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-gold mb-5">Reach Us</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Mail size={15} className="mt-0.5 text-gold" />
              <a href="mailto:mayuri@franglobal.com" className="hover:text-gold transition">
                mayuri@franglobal.com
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={15} className="mt-0.5 text-gold" />
              <a href="tel:+919811478372" className="hover:text-gold transition">
                +91 98114 78372
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={15} className="mt-0.5 text-gold" />
              Chandigarh Tricity · Ahmedabad · Delhi-NCR
            </li>
          </ul>
        </div>

        <div>
          <div className="overline text-gold mb-5">Follow</div>
          <div className="flex gap-3">
            <a
              href="https://www.linkedin.com/company/d32-business-network/"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="LinkedIn"
              data-testid="footer-social-linkedin"
              className="p-2 rounded-full border border-gray-700 hover:border-gold hover:text-gold transition"
            >
              <Linkedin size={16} />
            </a>
            <a
              href="https://www.instagram.com/d32businessnetwork/"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Instagram"
              data-testid="footer-social-instagram"
              className="p-2 rounded-full border border-gray-700 hover:border-gold hover:text-gold transition"
            >
              <Instagram size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-narrow py-6 text-xs text-gray-500 flex flex-col md:flex-row justify-between gap-2">
          <div>© {new Date().getFullYear()} D32 India Business Network. All rights reserved.</div>
          <div className="font-sans-display tracking-wider uppercase text-gold/80">
            The Power of Connection
          </div>
        </div>
      </div>
    </footer>
  );
}
